import { forwardRef, type MouseEvent } from 'react';
import { twMerge } from 'tailwind-merge';
import {
  default as MuiIconButton,
  type IconButtonProps as MuiIconButtonProps,
} from '@mui/material/IconButton';
import Tooltip, { type TooltipProps } from '@/components/Tooltip';
import type { IconButtonVariant } from './types';
import { classes, styles } from './utils';

export type { IconButtonVariant } from './types';

export interface IconButtonProps extends MuiIconButtonProps {
  disabled?: boolean;
  variant?: IconButtonVariant;
  title?: string;
  titlePosition?: TooltipProps['placement'];
  titleArrow?: boolean;
  onClick: (e: MouseEvent<HTMLButtonElement>) => void;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      disabled = false,
      variant,
      className,
      style = {},
      title,
      titlePosition,
      titleArrow,
      onClick,
      ...props
    },
    ref
  ) => {
    const button = (
      <MuiIconButton
        ref={ref}
        disabled={disabled}
        sx={{ ...styles.iconButton, ...style }}
        className={twMerge(
          disabled ? classes.disabledCursor : classes.pointerCursor,
          variant && classes.base,
          variant && classes[variant],
          className
        )}
        onClick={(e) => (disabled ? null : onClick(e))}
        {...props}
      />
    );
    return title ? (
      <Tooltip arrow={titleArrow} placement={titlePosition} title={title}>
        {button}
      </Tooltip>
    ) : (
      button
    );
  }
);

export default IconButton;
